/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Polite_Slimy_Mallard_SeekInputs */

const fr_polite_slimy_mallard_seek = /** @type {(inputs: Polite_Slimy_Mallard_SeekInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Répétitions max`)
};

/**

* @param {Polite_Slimy_Mallard_SeekInputs} inputs
* @param {{ locale?: "fr" }} options
* @returns {LocalizedString}
*/
export const polite_slimy_mallard_seek = /** @type {((inputs?: Polite_Slimy_Mallard_SeekInputs, options?: { locale?: "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Polite_Slimy_Mallard_SeekInputs, { locale?: "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return fr_polite_slimy_mallard_seek(inputs)
});